module.exports = __webpack_public_path__ + "static/media/chat-light-icon.decc8ec3.svg";